<template>
    <div class="comContent">
        <el-form ref="formTool" :model="formTool" :inline="true" style="text-align: left;margin-top: 20px;">
            <el-form-item prop="goodsSkuName" label="">
                <el-input v-model.trim="formTool.goodsSkuName" placeholder="请输入原品商品名称" clearable size="small" />
            </el-form-item>
            <el-form-item prop="erpCode" label="">
                <el-input v-model.trim="formTool.erpCode" placeholder="请输入商品ERP编码" clearable size="small" />
            </el-form-item>

            <el-form-item prop="extendType" label="审核状态">
                <el-select v-model="formTool.status" clearable style="width: 120px;" size="small" placeholder="类别">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="getList(1)">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="reset()">重置</el-button>
            </el-form-item>

        </el-form>

        <myTable :index="index" :selection="false" :page="page" :showpage="true" :operation="false" v-loading="loading"
            :table-data="tableData" :table-option.sync="tableOption" @page-change="getList" :expand="false">
            <template slot="status" slot-scope="scope">
               <span v-if="scope.row.status =='REJECT' ">驳回</span>
               <span v-if="scope.row.status =='PASS' ">通过</span>
               <span v-if="scope.row.status =='CHECKING' ">待审核</span>
               <span v-if="scope.row.status =='PUTAWAY' ">上架</span>
            </template>
            <template slot="operation" slot-scope="scope">
                <div style="margin: 0 0px">
                    <el-link type="primary" :underline="false" @click="HandlerClick(scope.row, 'audit')"
                    v-if="scope.row.status == 'CHECKING' "
                        style="margin-right: 10px">
                        审核
                    </el-link>
                    <el-link type="primary" :underline="false" @click="HandlerClick(scope.row, 'detail')"
                        style="margin-right: 10px">
                        详情
                    </el-link>
                </div>
            </template>
        </myTable>
        <goodsDialog ref="goodsDialog" /> 
     
    </div>
</template>
<script>

const options = [{
    label: '待审核',
    value: 'CHECKING'
}, {
    label: '审核通过',
    value: 'PASS'
}, {
    label: '驳回',
    value: 'REJECT'
}, {
    label: '上架',
    value: 'PUTAWAY'
}]
import myTable from "@/components/myTable";
import goodsDialog from "./components/goodsDialog";
import { giftPayeeListPlatform } from "@/api/gift";
export default {
    components: { myTable, goodsDialog },
    props: {},
    data() {
        return {
            options:options,
            expanded: false,
            isExpanded: false,
            loading: false,
            operation: true,
            selection: true,
            index: false,
            formTool: {},
            page: {
                total: 0,
                current: 1,
                size: 10,
                pageSizes: [10, 20, 30, 50],
            },
            tableData: [],
            tableOption: [
                { label: "店铺信息", prop: "shopName", },
                // { label: "运营人员&联系方式", prop: "shopName", },
                { label: "促销标题", prop: "promotionTitle", },
                { label: "原品", prop: "goodsSkuName", },
                { label: "赠品", prop: "giftSkuName", },
                // { label: "赠品数量", prop: "qty", },
                { label: "促销区域", prop: "promotionArea", },
                { label: "促销开始时间", prop: "startTime", },
                { label: "促销结束时间", prop: "endTime", },
                { label: "添加时间", prop: "createTime", },
                { label: "审核状态", prop: "status", slot: true },
                { label: "操作", prop: "operation", slot: true },
            ], 
        };
    },
    filters: {
        
    },
    created() { },
    mounted() {
        this.getList();
    },
    methods: {
        // 选择商品
        chooseGood(row) {
            this.dialogVisible = true;
            this.rowData = row;
        },
        choice(val) {
            this.rowData.skuList = val
            // this.beforeClose()
        },
        getList(current) {
            if (current) {
                this.page.current
            }
            let params = {};
            params.current = this.page.current;
            params.size = this.page.size;
            params.status = this.formTool.status;
            params.goodsSkuName = this.formTool.goodsSkuName;
            params.erpCode = this.formTool.erpCode;
            giftPayeeListPlatform(params).then((res) => {
                console.log(res, '--res')
                this.tableData = res.records;
                this.page.total = res.total;
            }).catch((err) => { })
        },

        goBack() {
            this.$router.back()
        },
        UpdateStatus() {

        },
        HandlerClick(row, type) {
            this.$router.push(`./salesControl-fullGiftOps-giftDetail?id=${row.id}&type=${type}`);
        },
        reset() {
            this.formTool = {}
            this.getList(1)
        },
        
    },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
    height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
    height: calc(100% - 118px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
    height: calc(100% - 78px) !important;
    overflow-y: scroll !important;
}

.expand-form {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}

.flex-box {
    display: flex;
    justify-content: space-between;
}
</style>
  